<template>
  <VueDraggableResizable :parent="true" :resizable="isEditable" :draggable="isEditable"
                         :x="xAnnotation"
                         :y="yAnnotation"
                         :w="wAnnotation"
                         :h="hAnnotation"
                         :grid="[10, 10]"
                         :min-width="50"
                         :min-height="50"
                         class="dragableAnnotationComponent"
                         :class-name="isEditable?'defaultClassDragAnnotation':'clickAnnotation'"
                         :class-name-dragging="isEditable?'onDragAnnotation':''"
                         @resizing="onResizeAnnotation"
                         @dragging="onDragAnnoation"
                         :z="30" :disableUserSelect="false">
    <transition name="zoom">
      <!-- ANNOTATION -->
      <div class="annotationPosition"  v-show="show"
           :id="'annotation-'+annotation.annotationID">
        <div class="annotation" :class="{editable:isEditable,notFocusable:!isAnnotationMode,focusable:isAnnotationMode}"
             :style="customStyle" :ref="'annotationContent-'+annotation.annotationID"
             :id="'annotationContent-'+annotation.annotationID" @click="selectAnnotation">
            <div class="annotationTextContainer" v-if="isText"
                 @focusin="onStartEditing"
                 @focusout="validateAnnotationContent"
                 v-show="show" :ref="'annotation-'+annotation.annotationID" :contenteditable="isEditable"
                 v-html="annotationContent"></div>
            <div class="svgContainer" v-html="inlineIconColored" v-if="isShape || isIcon"></div>
        </div>
      </div>

    </transition>
  </VueDraggableResizable>

</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Annotation, AnnotationType} from "@/store/annotation/annotationModel";
import VueDraggableResizable from 'vue-draggable-resizable';
import {Howl} from 'howler';
import UserAvatar from "@/components/user/UserAvatar.vue";
import WIcon from "@/components/wrapper/w-icon.vue";
import store from "@/store";
import {SELECT_ANNOTATION, UPDATE_ANNOTATION} from "@/store/annotation/annotationAction";
import {Weet} from "@/store/weet/weetModel";
import CenterCenterPanel from "@/components/layout/CenterCenter.vue";
import IconsSelector from "@/components/icons/IconsSelector.vue";
import WModal from "@/components/wrapper/w-modal.vue";
import {PUBLIC_PATH} from "@/store/conf/api";
import {getImageURLForSize, htmliFy} from "@/utils/util";
import {PLAYER_PLAYING} from "@/store/timeLine/timeLineAction";
import debounce from "lodash/debounce";
import {clone} from "@/utils/cloneUtil";
import {ANNOTATION_INTERACTION_SAVE_IN_PROGRESS} from "@/store/recordingState/recordStateAction";
import delay from "delay";
import {exportNode2PngDataURL} from "@/utils/ImageUtil";
import {h} from "vue";
import fitty, {FittyInstance} from "fitty";
import {blockClick, closeLoading, inform, informError, showLoading, unblockClick} from "@/utils/dialog";
import {UPDATE_ANNOTATION_ON_WEET} from "@/store/myWeet/myWeetAction";

@Component({
  methods: {h},
  components: {
    WModal, IconsSelector, CenterCenterPanel, WIcon, UserAvatar,
    VueDraggableResizable
  },
})
export default class AnnotationElementPlayerComponent extends Vue {

  private pop = new Howl({
    src: [PUBLIC_PATH + 'sound/pop.mp3'],
    volume: 0.80,
  });


  @Prop()
  private parentID!: string;

  @Prop()
  private annotation!: Annotation;
  @Prop()
  private weet!: Weet;
  @Prop({default: 0})
  private timePlayer!: number;

  @Prop({default: false})
  private miniMode!: boolean


  private annotationContainer!: HTMLDivElement;
  private fittyInstance: FittyInstance|null=null;

  private ready: boolean = false;

  private xAnnotation = 0;
  private yAnnotation = 0;
  private wAnnotation = 1;
  private hAnnotation = 1;
  private dragInProgress = false;
  private parent!: HTMLElement;
  private textContent = "";

  private inlineIcon=""
  private inlineIconColored="";

  // DEBOUCE METHODS
  private debounceOnDrag = debounce((el: any) => {
    el.dragInProgress = false;
  }, 1000);

  private debounceUpdateAnnotation = debounce((annotation) => {
    this.updateAnnotation(annotation, true);
  }, 250);
  private debounceResize = debounce(async (el) => {
    this.reinitPosition()
  }, 500);


  // GETTER

  get annotationContent() {
    if(this.isText) {
      return htmliFy(this.annotation.textContent);
    }else if(this.isImage) {
     return getImageURLForSize(this.annotation.urlContent, 600);
    }
    return '';
  }

  get isText() {
    return this.annotation.type === AnnotationType.TEXT;
  }

  get isImage() {
    return this.annotation.type === AnnotationType.IMAGE;
  }
  get isIcon() {
    return this.annotation.type === AnnotationType.ICON;
  }
  get isShape(){
    return this.annotation.type === AnnotationType.SHAPE;
  }

  get isSaveInProgress() {
    return store.getters.isAnnotationInteractionSaveInProgress;
  }

  get show() {
    return this.ready && this.timePlayer >= this.annotation.time &&
        this.timePlayer <= this.annotation.time + this.annotation.duration;
  }

  get isAnnotationMode(){
    return store.getters.isAnnotationMode
  }

  get isEditable() {
    if (store.getters.getAnnotationSelected) {
      return store.getters.getAnnotationSelected.annotationID === this.annotation.annotationID
          && store.getters.isAnnotationMode;
    }
    return false;
  }

  get customStyle() {
    let style = "";

    if(this.isText) {
      if (this.annotation.colorFront) {
        style += "color:" + this.annotation.colorFront + ";"
      }
      if (this.annotation.colorBack) {
        style += "background-color:" + this.annotation.colorBack + ";"
      }
    }else if (this.isImage){
      style+="background: url("+this.annotationContent+");"
      style+="background-size: cover;"
      style+="background-position:center center;"
    }else if(this.isIcon || this.isShape){
      style+="background: none;"
      style+="box-shadow: none;"

      let coloredSVG=this.inlineIcon;
      // Replace fill into <svg> tag
      if (/fill\s*=\s*["'].*?["']/.test(coloredSVG)) {
        coloredSVG= this.inlineIcon.replace(/fill\s*=\s*["'].*?["']/g, `fill="${this.annotation.colorFront}"`);
      }
      //  Inject fill and preserveAspectRatio into <svg> tag
      if (this.isShape) {
        coloredSVG = coloredSVG.replace(
            /<svg([^>]*)>/,
            `<svg$1 fill="${this.annotation.colorFront}" preserveAspectRatio="none"
              style='width:100%;height:100%;'>`
        );
      } else {
        coloredSVG = coloredSVG.replace(
            /<svg([^>]*)>/,
            `<svg$1 fill="${this.annotation.colorFront}"
              style='width:100%;height:100%;'>`
        );
      }
      this.inlineIconColored=coloredSVG
    }
    return style;
  }

  async mounted() {
    this.ready = true;
    // this.pop.play();
    this.initExternalComponent()
    window.addEventListener('resize', this.onResize)
    this.textContent = this.annotation.textContent;
    // setup the annotationContainer
    this.annotationContainer = this.$refs['annotation-' + this.annotation.annotationID] as HTMLDivElement;
    if(this.isText) {
      this.fittyInstance = fitty(this.annotationContainer, {
        minSize: 12,
        maxSize: 72,
      })
    }

    if(this.isIcon || this.isShape){
      const res = await fetch('https://cdn.jsdelivr.net/npm/@mdi/svg/svg/'+this.annotation.iconMD+'.svg');
      this.inlineIcon =await res.text();
    }

    this.onResize()


  }

  private setupAnotationWithPourcentage(x, y, w, h) {
    this.xAnnotation = this.parent.offsetWidth * x / 100;
    this.yAnnotation = this.parent.offsetHeight * y / 100;
    this.wAnnotation = this.parent.offsetWidth * w / 100;
    this.hAnnotation = this.parent.offsetHeight * h / 100;
  }

  private initExternalComponent() {
    const el = document.getElementById(this.parentID);
    if (el) {
      this.parent = el;
    } else {
      console.warn("Error no parent found for interaction")
    }
  }


  private selectAnnotation() {
    if (store.getters.isAnnotationMode) {
      store.dispatch(SELECT_ANNOTATION, this.annotation);
    }
  }

  private onDragAnnoation(left, top) {
    this.xAnnotation = left;
    this.yAnnotation = top;
    this.onDragOrResizeInProgress();
  }

  private onResizeAnnotation(left, top, width, height) {
    this.xAnnotation = left;
    this.yAnnotation = top;
    this.wAnnotation = width;
    this.hAnnotation = height;
    this.fittyInstance?.fit();
    this.onDragOrResizeInProgress()
  }

  private async onResize() {
    this.debounceResize(this);
  }

  private async reinitPosition() {
    this.setupAnotationWithPourcentage(this.annotation.positionX, this.annotation.positionY, this.annotation.width || 20, this.annotation.height || 20)
    this.fittyInstance?.fit();
  }


  private updateAnnotationPosition() {
    const x = this.xAnnotation / this.parent.offsetWidth * 100;
    const y = this.yAnnotation / this.parent.offsetHeight * 100;
    const w = this.wAnnotation / this.parent.offsetWidth * 100;
    const h = this.hAnnotation / this.parent.offsetHeight * 100;

    const annotationUpdated = clone(store.getters.getAnnotationSelected) as Annotation;
    if(annotationUpdated.positionX !== x
    || annotationUpdated.positionY !==y
    || annotationUpdated.width !==w
    || annotationUpdated.height !==h) {
      annotationUpdated.positionX = x;
      annotationUpdated.positionY = y;
      annotationUpdated.width = w;
      annotationUpdated.height = h;
      this.debounceUpdateAnnotation(annotationUpdated);
    }
  }

  private onDragOrResizeInProgress() {
    store.dispatch(PLAYER_PLAYING, false);
    this.dragInProgress = true;
    //inform the drag is ended
    this.debounceOnDrag(this);
    this.updateAnnotationPosition()
  }

  private async updateAnnotation(annotationUpdate: Annotation, withPicture) {
    // export img before update
    let dataUrlImage = '';
    store.dispatch(UPDATE_ANNOTATION_ON_WEET,{weetID:this.weet.weetID,annotation:clone(annotationUpdate)});

    if (withPicture) {
      const annotation = document.getElementById('annotation-' + this.annotation.annotationID);
      if (!annotation) {
        return;
      }
      // wait for annotation update
      await delay(50);
      dataUrlImage = await exportNode2PngDataURL(annotation);
      annotationUpdate.exportStaticUrl = dataUrlImage;
      store.dispatch(UPDATE_ANNOTATION_ON_WEET,{weetID:this.weet.weetID,annotation:clone(annotationUpdate)});

    }
    store.dispatch(SELECT_ANNOTATION,annotationUpdate)
    this.saveAnnotation(annotationUpdate)
  }

  private async saveAnnotation(annotationUpdate: Annotation){
    blockClick()
    await store.dispatch(ANNOTATION_INTERACTION_SAVE_IN_PROGRESS, true);
    await store.dispatch(UPDATE_ANNOTATION, {
      weetID: this.weet.weetID, annotation: annotationUpdate
    }).then((backendAnnotation) => {
      inform(this.$t('createWeetComponent.advancedEditing.annotationMode.edit.success').toString());
      store.dispatch(ANNOTATION_INTERACTION_SAVE_IN_PROGRESS, false);
      unblockClick()
    }).catch(() => {
      unblockClick()
      informError(this.$t('createWeetComponent.advancedEditing.annotationMode.edit.error').toString());
      store.dispatch(ANNOTATION_INTERACTION_SAVE_IN_PROGRESS, false);
    })
  }

  private onStartEditing() {
    this.$emit('onEdit', true)
  }

  private validateAnnotationContent(event: Event) {
    this.$emit('onEdit', false)
    if (event.target != null) {
      const element = event.target as HTMLElement;
      if (htmliFy(element.innerText).trim() !== this.annotation.textContent) {
        this.textContent = htmliFy(element.innerText).trim();
        var annotationUpdate = clone(store.getters.getAnnotationSelected) as Annotation;
        annotationUpdate.textContent=this.textContent;
        this.updateAnnotation(annotationUpdate,true);
      }
    }
  }

  beforeDestroy() {
    this.fittyInstance?.unsubscribe();
    window.removeEventListener('resize', this.onResize);
  }

}
</script>

<style scoped lang="scss">
@import '@/scss/shadows.scss';

.dragableAnnotationComponent {
  position: absolute;
}

.annotationPosition {
  position: absolute;
  z-index: 30;
  height: 100%;
  width: 100%;
  animation-duration: 0.5s;

  .annotation {
    height: 100%;
    width: 100%;
    pointer-events: auto;
    background: white;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 2px transparent;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);

    &.editable {
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.7);
      filter: drop-shadow(10px 10px 15px rgba(0, 0, 0, 0.7));
    }
    &.notFocusable{
      pointer-events: none;
    }
    &.focusable:hover{
      border: solid 2px var(--primary);
    }

    .annotationTextContainer {
      padding: 16px;
      animation-delay: 0.1s;

      &[placeholder]:empty::before {
        content: attr(placeholder);
        color: var(--light1);
      }

      &[placeholder]:empty:focus::before {
        content: "";
      }
    }
    .svgContainer{
      width: 100%;
      height: 100%;
      pointer-events: none;
      transform: scale(1.16);
      transform-origin: center;
      svg{
        width: 100%;
        height: 100%;
      }
    }
  }
}


</style>

<style lang="scss">
.uploadElement {
  .upload-draggable {
    border: 0px;
    height: 100%;
    border-radius: 12px;

  }
}

.defaultClassDragAnnotation {
  background-color: transparent;
  border: none;
  cursor: grab;

  .handle {
    pointer-events: all;
  }
}

.onDragAnnotation {
  cursor: move;
  opacity: 0.8;
}

.clickAnnotation {
  cursor: pointer;
}
</style>
